import { toRadians } from '../../../utils';

export const START_ANGLE = 0;
export const END_ANGLE = toRadians(360);

export const START = 'start';
export const END = 'end';
